<template>
    <div v-if="shouldShow" class="fixed inset-x-0" style="top:0; height: 5px;">
        <div class="absolute inset-y-0 left-0 bg-primary" :style="{width: Math.round(done/total*100) + '%' }"></div>
    </div>
</template>

<script>
import { eventBus } from '@/eventBus';

export default {


    data: () => ({
        message: null,
        done: null,
        total: null,
        shouldShow: false,
    }),

    created() {
        eventBus.$on('uploadProgress', (data) => {
            this.message = data.message;
            this.done = data.done;
            this.total = data.total;
            this.shouldShow = true;
        });

        eventBus.$on('uploadDone', (data) => {
            this.shouldShow = false;
            this.message = null;
            this.done = null;
            this.total = null;
        });
    },


    methods: {

    },
};
</script>
